(() => {
  if (customElements.get('kiblem-cod')) return;
  class KiblemCod extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.core = window.KiblemCodCore;
      this.cities = window.KiblemCities || {};
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.step = 0;
      this.pending = null;
      this.busy = false;
      this.completed = false;
      this.offer = this.querySelector('[data-cod-exit-offer]');
      this.body = this.querySelector('.kiblem-cod-body');
      this.originalTitle = this.dialog.getAttribute('aria-labelledby');
      this.offerShown = false;
      this.offerAccepted = false;
      try {
        this.offerAccepted = sessionStorage.getItem('kiblem-exit5-accepted') === '1';
      } catch { /* The accepted discount remains available in memory when storage is unavailable. */ }
      this.live = this.dataset.enabled === 'true' && this.validEndpoint(this.dataset.endpoint);
      this.querySelector('[data-cod-preview]').hidden = this.live;
      const owner = this.closest('kiblem-landing');
      owner.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-kiblem-open-order], [data-kiblem-sticky] a, .kiblem-header-link, [data-kiblem-cta]');
        if (!trigger) return;
        event.preventDefault();
        this.offerShown = false;
        this.opener = trigger;
        this.dialog.showModal();
        window.KiblemMeta?.track('AddToCart', this.core.total(this.values().upsell, this.offerAccepted) / 100, `cart-${crypto.randomUUID()}`, 'cod-cart');
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }, { signal });
      this.querySelectorAll('[data-cod-close]').forEach((button) => button.addEventListener('click', () => this.requestClose(), { signal }));
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.requestClose();
      }, { signal });
      this.querySelector('[data-cod-offer-accept]').addEventListener('click', () => {
        this.offerAccepted = true;
        try { sessionStorage.setItem('kiblem-exit5-accepted', '1'); } catch { /* No personal information is stored. */ }
        this.restoreOrder();
        this.showStep(this.step);
      }, { signal });
      this.querySelector('[data-cod-offer-decline]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('close', () => {
        this.restoreOrder();
        document.documentElement.style.overflow = this.previousOverflow ?? '';
        this.opener?.focus();
      }, { signal });
      this.querySelector('[data-cod-next]').addEventListener('click', () => {
        this.showStep(this.step + 1);
      }, { signal });
      this.querySelector('[data-cod-back]').addEventListener('click', () => this.showStep(this.step - 1), { signal });
      const province = this.form.elements.il;
      Object.keys(this.cities).forEach((name) => province.add(new Option(name, name)));
      province.addEventListener('change', () => {
        const district = this.form.elements.ilce;
        district.replaceChildren(new Option(province.value ? 'İlçe seçin' : 'Önce il seçin', ''));
        (this.cities[province.value] || []).forEach((name) => district.add(new Option(name, name)));
        district.disabled = !province.value;
      }, { signal });
      this.form.addEventListener('change', () => this.sync(), { signal });
      this.form.addEventListener('input', (event) => {
        if (event.target.getAttribute('aria-invalid') === 'true') {
          const errors = this.core.validate(this.values(), this.cities);
          if (!errors[event.target.name]) this.setError(event.target.name, '');
        }
      }, { signal });
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.submit(); }, { signal });
      this.sync();
    }
    restoreOrder() {
      this.offer.hidden = true;
      this.body.hidden = false;
      this.dialog.setAttribute('aria-labelledby', this.originalTitle);
    }
    requestClose() {
      if (!this.offerShown && !this.offerAccepted && !this.busy && !this.pending && !this.completed) {
        this.offerShown = true;
        this.body.hidden = true;
        this.offer.hidden = false;
        this.dialog.setAttribute('aria-labelledby', this.offer.querySelector('h2').id);
        this.querySelector('[data-cod-offer-accept]').focus();
        return;
      }
      this.dialog.close();
    }
    validEndpoint(value) {
      try { const url = new URL(value); return url.protocol === 'https:' && !url.username && !url.password; } catch { return false; }
    }
    values() {
      const values = Object.fromEntries(new FormData(this.form));
      values.payment_method = 'cash_or_card';
      values.exit_offer = this.offerAccepted;
      values.upsell = this.form.elements.upsell.checked;
      return values;
    }
    setError(name, message) {
      const error = this.querySelector(`[data-error="${name}"]`);
      if (error) error.textContent = message;
      this.form.querySelectorAll(`[name="${name}"]`).forEach((input) => {
        input.setAttribute('aria-invalid', String(Boolean(message)));
        if (error) input.setAttribute('aria-describedby', error.id);
      });
    }
    validate() {
      const errors = this.core.validate(this.values(), this.cities);
      ['first_name', 'last_name', 'phone', 'il', 'ilce', 'address', 'note'].forEach((name) => this.setError(name, errors[name] || ''));
      const names = Object.keys(errors);
      if (names.length) {
        this.showStep(1);
        this.form.querySelector(`[name="${names[0]}"]`)?.focus();
      }
      return !names.length;
    }
    showStep(step) {
      if (this.pending || this.busy || this.completed) return;
      this.step = Math.max(0, Math.min(1, step));
      this.querySelectorAll('[data-cod-panel]').forEach((panel) => { panel.hidden = Number(panel.dataset.codPanel) !== this.step; });
      this.querySelectorAll('[data-cod-progress]').forEach((item) => {
        if (Number(item.dataset.codProgress) === this.step) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      this.querySelector('[data-cod-back]').hidden = this.step === 0;
      this.querySelector('[data-cod-next]').hidden = this.step === 1;
      this.querySelector('[data-cod-submit]').hidden = this.step !== 1;
      this.querySelector('[data-cod-next]').textContent = 'Teslimat Bilgilerine Geç ↗';
      this.querySelector('[data-cod-submit]').textContent = this.live ? 'Siparişi Onayla' : 'Formu Kontrol Et';
      this.querySelector('[data-cod-status]').textContent = '';
      this.sync();
      const panel = this.querySelector(`[data-cod-panel="${this.step}"]`);
      if (this.step === 1) window.KiblemMeta?.track('InitiateCheckout', this.core.total(this.values().upsell, this.offerAccepted) / 100, `checkout-${crypto.randomUUID()}`, 'cod-checkout');
      panel.tabIndex = -1;
      panel.focus({ preventScroll: true });
      panel.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    sync() {
      const values = this.values();
      this.querySelector('[data-cod-total]').textContent = this.core.format(this.core.total(values.upsell, values.exit_offer));
      this.querySelector('[data-cod-discount-row]').hidden = !this.offerAccepted;
      this.querySelector('[data-cod-discount-notice]').hidden = !this.offerAccepted;
      this.querySelector('[data-cod-upsell-row]').hidden = !values.upsell;
      this.querySelector('[data-cod-selection]').textContent = values.upsell ? 'Eklendi · Kaldırmak için dokunun' : 'Seccadeyi ekle';
    }
    lock(locked) {
      this.form.querySelectorAll('input, select, textarea, [data-cod-back]').forEach((input) => { input.disabled = locked; });
      if (!locked) this.form.elements.ilce.disabled = !this.form.elements.il.value;
    }
    async submit() {
      if (this.busy || this.completed) return;
      if (this.step === 0) {
        this.showStep(1);
        return;
      }
      const status = this.querySelector('[data-cod-status]');
      if (!this.pending && !this.validate()) return;
      if (!this.live) {
        status.textContent = 'Form kontrolü tamamlandı. Önizleme modundasınız; bilgileriniz gönderilmedi ve sipariş oluşturulmadı.';
        return;
      }
      if (!this.pending) {
        this.pending = this.core.buildPayload(this.values(), crypto.randomUUID());
        this.pending.tracking = window.KiblemMeta?.context() || { marketing_consent: false };
      }
      // A retry keeps its order identity but must respect a later consent withdrawal.
      if (this.pending.tracking.marketing_consent && window.KiblemMeta?.context().marketing_consent !== true) this.pending.tracking = { marketing_consent: false };
      this.lock(true);
      this.busy = true;
      this.form.setAttribute('aria-busy', 'true');
      const submit = this.querySelector('[data-cod-submit]');
      submit.disabled = true;
      submit.textContent = 'Siparişiniz gönderiliyor…';
      status.textContent = '';
      this.request = new AbortController();
      const timer = setTimeout(() => this.request.abort(), 25000);
      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.pending), signal: this.request.signal, credentials: 'omit', redirect: 'error'
        });
        const result = await response.json();
        if (response.ok && result.ok === true && result.event_id === this.pending.event_id && result.order?.id && result.order?.name) {
          this.completed = true;
          if (this.pending.tracking.marketing_consent === true) window.KiblemMeta?.track('Purchase', this.pending.total_minor / 100, this.pending.event_id);
          this.form.hidden = true;
          this.querySelector('[data-cod-confirmation]').textContent = `Sipariş numaranız: ${String(result.order.name)} · ${this.core.format(this.pending.total_minor)}`;
          const done = this.querySelector('.kiblem-cod-done');
          done.hidden = false;
          done.focus();
          this.querySelector('.kiblem-cod-progress').hidden = true;
        } else if (result.ok === false && result.status === 'rejected' && result.event_id === this.pending.event_id) {
          this.pending = null;
          this.lock(false);
          status.textContent = 'Sipariş oluşturulmadı. Bilgilerinizi kontrol edip tekrar deneyin.';
        } else {
          throw new Error('Unconfirmed order');
        }
      } catch {
        status.textContent = 'Sipariş sonucu henüz doğrulanamadı. Yeniden denediğinizde aynı sipariş numarasıyla kontrol edilir; bilgileriniz tekrar sipariş oluşturmak için değiştirilmez.';
      } finally {
        clearTimeout(timer);
        this.busy = false;
        this.form.setAttribute('aria-busy', 'false');
        submit.disabled = false;
        submit.textContent = this.pending ? 'Sipariş Durumunu Yeniden Kontrol Et' : 'Siparişi Onayla';
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.request?.abort();
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow ?? '';
      }
    }
  }
  customElements.define('kiblem-cod', KiblemCod);
})();
